export const SEARCH_APPLY_FILTER = "SEARCH_APPLY_FILTER";
export const SEARCH_APPLY_SORT = "SEARCH_APPLY_SORT";
export const SEARCH_UPDATE_FILTERS = "SEARCH_UPDATE_FILTERS";
export const SEARCH_UPDATE_RESULTS = "SEARCH_UPDATE_RESULTS";
export const SEARCH_PAGINATE = "SEARCH_PAGINATE";
export const SEARCH_UPDATE_LAYOUT = "SEARCH_UPDATE_LAYOUT";
export const SEARCH_UPDATE_INDEX = "SEARCH_UPDATE_INDEX";
export const SEARCH_UPDATE_ACTIVE_RESULT_TEMPLATE = "SEARCH_UPDATE_ACTIVE_RESULT_TEMPLATE";
export const SEARCH_SET_IS_LOADING = "SEARCH_SET_IS_LOADING";

export const OVERLAY_OPEN = "OVERLAY_OPEN";
export const OVERLAY_CLOSE = "OVERLAY_CLOSE";

// LM 360
export const UPDATE_ACTIVE_THREE_SIXTY_COMPONENT = "UPDATE_ACTIVE_THREE_SIXTY_COMPONENT";
export const UPDATE_ACTIVE_INSTANCE_NAME = "UPDATE_ACTIVE_INSTANCE_NAME";
